import { createContext, useContext } from 'react'

const FormDisabledContext = createContext(false)

export const useFormDisabled = (): boolean => useContext(FormDisabledContext)
export default FormDisabledContext
